import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-satisfaction-satisfactions',
  templateUrl: './satisfaction-satisfactions.component.html',
  styleUrls: ['./satisfaction-satisfactions.component.scss']
})
export class SatisfactionSatisfactionsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
